<template>
  <el-dialog title="Lieferantenzuweisung bearbeiten" :visible="show" @close="close"
    width="30%"
  >
    <div class="row">
      <div class="col-sm-12">
        <form @submit.prevent="submit">
          <fg-input label="EAN / Artikelnummer"
            type="text"
            v-model="referenznummer"
          />
          <fg-input label="Preis"
            type="text"
           :value="price"
            @input="price = $event"
          />
          <div class="d-flex justify-content-between">
            <button type="submit" class="btn btn-fill btn-primary">
              Speichern
            </button>
            <button class="btn btn-fill btn-default"
              @click.prevent="close"
            >
              Abbrechen
            </button>
          </div>
        </form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import priceWatcher from 'src/pages/Products/price-watcher'

export default {
  props: ['show', 'initReferenznummer', 'initPrice'],
  components: { [Dialog.name]: Dialog },
  mixins: [priceWatcher],
  data () {
    return {
      referenznummer: this.initReferenznummer,
      productPrice: ''
    }
  },
  computed: {
  },
  methods: {
    submit () {
      this.$emit('updateProductSupplier', {
        referenznummer: this.referenznummer,
        price: this.productPrice
      })
    },
    getPrice () {
      return this.productPrice
    },
    setPrice (price) {
      this.productPrice = price
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style>
</style>
